<template>
    <div class="page-body">
        <div class="m-breadcrumbBox f-cb" style="width: 1140px;margin: auto;">
            <div class="g-mn2">
                <div class="g-flow f-cb">
                    <ul class="g-flow">
                        <li class="navcrumb-item">
                            <a href="/livere/llst" target="_self">返回</a>
                        </li>
                        <li class="navcrumb-item" id="navcrumbId-1">
                            <span class="arrow"></span>
                            <a href="" target="_self">刷新</a>
                        </li>
                        <li class="navcrumb-item" id="navcrumbId-2">
                            <span class="arrow"></span>
                            <a href="javascript:void(0)">课堂直播</a>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
        <div class="md2018040803lty bgcolor-fff" style="height: 500px">
            <div class="container">

                <vue-aliplayer-v2 class="multiple-player" style="width: 1200px;height: 500px;" :key="x" :source="src"
                    ref="VueAliplayerV2" :options="options" />
                <!-- <div class="prism-player" id="player-con" style="width: 1200px;height: 500px;"></div> -->
                <!-- <ali-player style="margin: auto;" :useFlashPrism="true" :autoplay="true" :isLive="true" :rePlay="false"
                    :showBuffer="true" showBarTime="5000" width="1200px" height="500px" controlBarVisibility="hover"
                    :source="src">
                </ali-player> -->



                <!-- <videoPlayer v-if="flag" ref="videoPlayer"  class="vjs-custom-skin videoPlayer" :options="playerOptions"></videoPlayer>  -->
                <!-- <div v-if="flag" id="player-con"></div> -->
            </div>
        </div>

        <v-tabs active-tab-key="key1" @change="onChange" @tab-click="onTabClick" style="margin: auto;width: 1140px;">
            <!-- 课程简介 -->
            <v-tab-pane tab-key="key1" tab="课程简介" style="background: #f6f5fa;">

                <div v-if="courseIntroflag" style="text-align: center;color: #888888;height: 500px;line-height: 600px;">
                    暂无课程简介</div>


                <div style="text-indent: 2em; color: #888888;height: 500px;" v-html="courseDetailInfo.courseIntro">
                </div>

            </v-tab-pane>
            <!-- 名师风采 -->
            <v-tab-pane tab-key="key2" tab="名师风采" style="background: #f6f5fa;">


                <div v-if="teacherIntroflag"
                    style="text-align: center;color: #888888;height: 500px;line-height: 600px;">暂无老师简介</div>

                <div v-html="courseDetailInfo.teacherIntro"></div>
            </v-tab-pane>
            <!-- 课程评论 -->
            <v-tab-pane tab-key="key3" tab="课程评论">

                <div class="item" style="width: 100%;display: block; min-height: 600px;">
                    <el-input type="textarea" v-model="evaluateVal" placeholder="请填写课程评论"></el-input>
                    <div class="edit-bt">
                        <div class="star-area ver-top">
                            <span id="scoureId" class="font-16 color-333 ver-top"
                                style="margin-right: 5px;font-size: 18px;font-weight: bold;">星级</span>
                            <v-rate v-model="star1" @change="_change"></v-rate>
                        </div>
                        <ul class="lab-list ver-top" id="js_lab_list">
                        </ul>
                        <p class="ver-top text-right">
                            <button type="button" class="form-btn form-btn-blue" style="position: absolute;right: 20px;"
                                @click="evaluate">评论</button>
                        </p>
                    </div>
                    <div class="comment-area">
                        <p class="color-666 comm-tit bgcolor-f6f5fa">
                            全部评论<span id="commentSize">({{count}})</span>
                        </p>


                        <div v-for="(item,index) in evaluateListData" :key="index" class="comm-list"
                            id="commentInfoDiv">
                            <div class="comm-box clearfix">
                                <div class="tx pull-left text-center">
                                    <div class="md-2018040801-lty"><img src="../../../static/img/head.svg" alt=""
                                            onerror="this.onerror=null;this.src='/img/head.svg'"></div>
                                    <p class="nc font-14">{{item.user_name}}</p>
                                </div>
                                <div class="comm-con">
                                    <v-rate class="star-num star-1" v-model="item.rate" :disabled="true"></v-rate>
                                    <!--star-1:一颗星；star-2：两颗星；star-3:三颗星；star-4:四颗星；star-5:五颗星-->
                                    <p class="font-14">{{item.content}}</p><span
                                        class="comm-t color-999 font-14">{{item.create_time}}</span>
                                </div>
                            </div>
                        </div>

                        <p v-if="evaluateFlag" class="none-commentlty text-center font-14 hide">暂无评论</p>
                    </div>

                </div>



            </v-tab-pane>
        </v-tabs>
    </div>

</template>


<script>
    //import aliplayer from "./AliPlayer.vue";
    //import 'video.js/dist/video-js.css'
    //import { videoPlayer } from 'vue-video-player'
    //import 'videojs-contrib-hls/dist/videojs-contrib-hls'
    //import 'videojs-flash'
    //import 'vue-video-player/src/custom-theme.css'
    //import SWF_URL from 'videojs-swf/dist/video-js.swf'
    export default {
        name: 'videojs',
        components: {
            // videoPlayer
            //"ali-player": aliplayer
        },
        data() {
            return {
                options: {
                    // source:'//player.alicdn.com/video/aliyunmedia.mp4',
                    isLive: true,   //切换为直播流的时候必填（true-直播状态，false-普通模式，播放器普通视频）
                },
                source: 'rtmp://23.166.0.133:30140/vpaas/34020000001310000207356ABC00',
                show: true,
                isShowMultiple: false,
                evaluateListData: [],
                count: 0,
                evaluateVal: '',
                star1: 1,
                courseIntroflag: false,
                teacherIntroflag: false,
                src: '',
                playerOptions: {
                    // videojs options
                    muted: true,
                    techOrder: ['flash'],
                    autoplay: false,
                    controls: true,
                    language: 'en',
                    //playbackRates: [0.7, 1.0, 1.5, 2.0],
                    sources: [{
                        type: "rtmp/flv",
                        //http://clips.vorwaerts-gmbh.de/big_buck_bunny.mp4
                        //rtmp://58.200.131.2:1935/livetv/hbtv
                        src: ''
                    }],
                    //课程相关

                },
                courseDetailInfo: {
                    courseIntro: '',
                    teacherName: '',
                    teacherIntro: '',
                    courseHourList: []
                },
                evaluateFlag: false
            }
        },
        created() {
            //this.loadLive(this.$route.params.streamName);
            // this.playerOptions.sources[0].src = this.$route.params.streamName;
            //this.load();
            // this.playerOptions.sources[0].src = this.$storage.get('rtm');
            this.src = this.$storage.get('rtm');

            //console.log("课程id============"+this.$route.params.courseId)
            this.courseDetail(this.$route.params.courseId, this.$route.params.liveId);
            //加载课程评价
            this.loadEvaluateListData(this.$route.params.courseId);
        },
        mounted() {
        },
        beforeDestroy() {
        },
        methods: {
            play() {
                this.$refs.VueAliplayerV2.play()
            },
            pause() {
                this.$refs.VueAliplayerV2.pause();
            },
            replay() {
                this.$refs.VueAliplayerV2.replay();
            },
            getCurrentTime() {
                // this.$refs.VueAliplayerV2.getCurrentTime();
                this.source = 'http://ivi.bupt.edu.cn/hls/cctv1.m3u8';
            },
            getStatus() {
                const status = this.$refs.VueAliplayerV2.getStatus();
                console.log(`getStatus:`, status);
                alert(`getStatus:${status}`);
            },
            showMultiple() {
                this.isShowMultiple = !this.isShowMultiple;
            },
            //评价
            evaluate() {
                if (this.evaluateVal === '') {
                    this.$message({
                        message: '请填写评价内容哦！',
                        type: 'warning'
                    });

                    return false;
                }

                let parames = new URLSearchParams();

                parames.append('evalContent', this.evaluateVal); //评价内容

                parames.append('courseId', this.$route.params.courseId); //课程id

                parames.append('score', this.star1);//分数

                parames.append('userId', this.$storage.get("declareUser").id);

                parames.append('courseName', this.$route.params.courseName);

                //获取 当前等级下的上传资料 列表
                this.$axios.post(this.serverUrl + '/el/addComment', parames).then(resp => {

                    if (resp.data.code === '1') {

                        this.star1 = 1;

                        this.evaluateVal = '';

                        this.$message({
                            message: '评价成功，管理员审核中，请耐心等待^_^',
                            type: 'success'
                        });
                    } else {
                        this.$message.error('评价失败，请稍后再试！');
                    }
                }).catch(err => {
                    this.$message({
                        showClose: true,
                        message: '服务器繁忙，稍后重试！',
                        type: 'error'
                    });
                })


            },
            loadEvaluateListData(courseId) {
                let parames = new URLSearchParams();
                parames.append('courseId', courseId);
                //获取 当前等级下的上传资料 列表
                this.$axios.post(this.serverUrl + '/el/commentList', parames).then(resp => {


                    if (resp.data.data.length > 0) {
                        let ArrayList = [];
                        for (let i = 0; i < resp.data.data.length; i++) {
                            let evaluateEnter = resp.data.data[i];
                            let evaluateGo = {
                                header_img: '',
                                user_name: '',
                                rate: 0,
                                create_time: '',
                                content: ''
                            };
                            if (evaluateEnter.headPath != null) {
                                evaluateGo.header_img = this.serverUrl + this.prefiexUrl + evaluateEnter.headPath; //用户头像
                            } else {
                                evaluateGo.header_img = '../../../static/img/head.svg';
                            }

                            evaluateGo.user_name = evaluateEnter.userName; //用户姓名
                            evaluateGo.rate = evaluateEnter.score; //用户评分
                            evaluateGo.content = evaluateEnter.evalContent; //评价内容
                            evaluateGo.create_time = evaluateEnter.evalTime.substring(0, 10);

                            ArrayList.push(evaluateGo);
                        }
                        this.evaluateListData = ArrayList;
                        this.count = resp.data.data.length

                    } else {
                        this.evaluateFlag = true;
                        this.count = 0;
                    }
                }).catch(err => {
                    this.$message({
                        showClose: true,
                        message: '服务器繁忙，稍后重试！',
                        type: 'error'
                    });
                })
            },
            _change(val) {
                this.star1 = val;
            },
            courseDetail(courseId, liveId) {
                let parames = new URLSearchParams();

                parames.append('courseId', courseId);

                parames.append('liveId', liveId);

                //获取 当前等级下的上传资料 列表
                this.$axios.post(this.serverUrl + '/el/selectWorkTypeLiveCourse', parames).then(resp => {

                    if (resp.data.code === '1') {
                        //课程简介
                        if (resp.data.data.courseSummary === null) {
                            this.courseIntroflag = true;
                            this.courseDetailInfo.courseIntro = '';
                        } else {
                            console.log(resp.data.data.contentSummary)
                            this.courseDetailInfo.courseIntro = resp.data.data.contentSummary;

                        }
                        //老师姓名
                        this.courseDetailInfo.teacherName = resp.data.data.userName;

                        //老师简介
                        if (resp.data.data.userResume === null) {

                            this.teacherIntroflag = true;
                            this.courseDetailInfo.teacherIntro = '';
                        } else {
                            this.courseDetailInfo.teacherIntro = resp.data.data.userResume;
                        }
                    } else {
                        this.courseIntroflag = true;
                        this.teacherIntroflag = true;
                    }

                }).catch(err => {
                    this.$message({
                        showClose: true,
                        message: '服务器繁忙，稍后重试！',
                        type: 'error'
                    });
                })
            }

        }
    }
</script>

<style scoped>
    div /deep/ .el-textarea__inner {
        display: block;
        resize: vertical;
        padding: 5px 15px;
        line-height: 1.5;
        -webkit-box-sizing: border-box;
        height: 110px;
        box-sizing: border-box;
        width: 100%;
        font-size: inherit;
        color: #606266;
        background-color: #FFF;
        background-image: none;
        border: 1px solid #DCDFE6;
        border-radius: 4px;
    }

    .color-999 {
        color: #999;
    }

    .comm-con>p {
        color: #161616;
        margin-bottom: 20px;
    }

    .pull-right {
        float: right;
    }

    .comm-con {
        width: 767px;
    }

    .font-14 {
        font-size: 14px;
    }

    .nc {
        color: #161616;
        word-wrap: break-word;
    }

    .md-2018040801-lty img {
        width: 100%;
        height: 100%;
        border-radius: 50%;
    }

    .md-2018040801-lty {
        margin: 0 auto;
        width: 50px;
        height: 50px;
        border: 0;
    }

    .pull-left {
        float: left;
    }

    .text-center {
        text-align: center;
    }

    .tx {
        width: 75px;
    }

    .comm-box {
        padding: 20px 0;
        border-bottom: 1px solid #f6f5fa;
    }

    .bgcolor-f6f5fa {
        background: #f6f5fa;
    }

    .color-666 {
        color: #666;
    }

    .comm-tit {
        height: 46px;
        line-height: 46px;
        padding: 0 20px;
        font-size: 14px;
    }

    .form-btn {
        display: inline-block;
        padding: 6px 12px;
        margin-bottom: 0;
        font-size: 14px;
        font-weight: normal;
        line-height: 1.42857143;
        text-align: center;
        white-space: nowrap;
        vertical-align: middle;
        -ms-touch-action: manipulation;
        touch-action: manipulation;
        cursor: pointer;
        -webkit-user-select: none;
        -moz-user-select: none;
        -ms-user-select: none;
        user-select: none;
        background-image: none;
        border: 1px solid transparent;
        border-radius: 4px;
        height: 40px;
    }

    .form-btn-blue {
        color: #fff;
        background-color: #4b95ff;
        border-color: #4b95ff;
    }

    .edit-bt>p button {
        width: 100px;
    }

    .ver-top {
        display: inline-block;
        vertical-align: top;
    }

    .star-area {
        width: 200px;
    }

    .edit-bt {
        margin: 20px 0 30px 0;
    }

    .leave-msg-area {
        width: 100%;
        height: 138px;
        border: 1px solid #e0e0e0;
        border-radius: 5px;
        padding: 5px;
    }

    .item {
        display: none;
        padding: 15px 20px;
    }

    div /deep/ .ant-tabs-nav .ant-tabs-tab {
        display: inline-block;
        height: 100%;
        margin-right: 60px;
        -webkit-box-sizing: border-box;
        box-sizing: border-box;
        position: relative;
        padding: 35px 20px 10px 20px;
        -webkit-transition: color .3s cubic-bezier(.645, .045, .355, 1);
        transition: color .3s cubic-bezier(.645, .045, .355, 1);
        cursor: pointer;
        text-decoration: none;
        font-size: 16px;
    }

    .page-header,
    .page-con,
    .page-body,
    .page-footer {
        min-width: 1200px;
    }

    .uc-live-list .live-list-lives .um-live-live-card .um-live-live-card-tit,
    .uc-live-list .live-list-lives .um-live-live-card .um-live-live-card-subtit {
        width: 100%;
        margin: 0;
        padding: 0 12px;
        box-sizing: border-box;
    }

    .uc-live-list .live-list-lives .um-live-live-card .um-live-live-card-tit {
        font-size: 14px;
        margin: 8px 0;
        line-height: 22px;
        max-height: 44px;
        word-break: break-all;
        position: relative;
        overflow: hidden;
        display: -ms-flexbox;
        display: box;
        text-overflow: ellipsis;
        -webkit-line-clamp: 2;
    }

    .uc-live-list .live-list-lives .um-live-live-card .um-live-live-card-action {
        position: absolute;
        top: 155px;
        width: 100%;
        height: 30px;
        margin: 0;
        background: #fff;
        line-height: 30px;
        padding-left: 12px;
        box-sizing: border-box;
    }

    .uc-live-list .live-list-lives .um-live-live-card .um-live-live-card-action.z-joining,
    .uc-live-list .live-list-lives .um-live-live-card .um-live-live-card-action.z-join {
        background: #49AF4F;
    }

    .uc-live-list .live-list-lives .um-live-live-card .um-live-live-card-head img {
        height: 225px;
        border-radius: 0;
    }

    .uc-live-list .live-list-lives .um-live-live-card .um-live-live-card-head {
        float: none;
        width: 100%;
        height: 185px;
        margin: 0;
        overflow: hidden;
    }

    .um-live-live-card {
        overflow: hidden;
        cursor: pointer;
    }

    .um-live-live-card.z-col-3 {
        display: inline-block;
        padding: 12px;
        margin-right: 24px;
        width: 370px;
        vertical-align: top;
        margin-bottom: 4px;
    }

    .uc-live-list .live-list-lives .um-live-live-card {
        position: relative;
        width: 225px;
        height: 273px;
        padding: 0;
        background: #fff;
        margin-right: 20px;
        margin-bottom: 20px;
    }

    .uc-live-list .live-list-lives {
        width: 1250px;
        margin-top: 32px;
        margin-bottom: 40px;
    }

    .m-live-tab-list .live-list-tab {
        display: inline-block;
        color: #666;
        padding: 2px 5px;
        border-radius: 4px;
        font-size: 14px;
        margin-right: 25px;
        cursor: pointer;
    }

    .m-live-tab-list .live-list-tab.current {
        color: #fff;
        background: #FF3F29;
    }

    .m-live-tab-list .live-list-tabs {
        margin-left: -5px;
        padding-bottom: 20px;
        font-size: 0;
        line-height: 19px;
    }

    .m-live-tab-list {
        background: #fff;
    }

    .m-breadcrumbBox .navcrumb-item>a {
        vertical-align: middle;
        font-size: 14px;
    }

    .m-breadcrumbBox .navcrumb-item:last-child a {
        cursor: default;
        color: #999;
    }

    .m-breadcrumbBox .arrow {
        display: inline-block;
        width: 6px;
        height: 10px;
        background: url(//nos.netease.com/test-edu-image/C9F43C8E56FF6C953BF9ECA24368BA15.png) no-repeat;
        background-size: 6px 10px;
        margin: 0 10px;
        vertical-align: middle;
    }

    .m-breadcrumbBox .navcrumb-item {
        display: inline-block;
        height: 20px;
        line-height: 20px;
        font-size: 0;
    }

    .m-breadcrumbBox .navcrumb-item a {
        color: #666;
    }

    .m-breadcrumbBox .navcrumb-item>a {
        vertical-align: middle;
        font-size: 14px;
    }

    .m-breadcrumbBox .navcrumb-item {
        display: inline-block;
        height: 20px;
        line-height: 20px;
        font-size: 0;
    }

    .g-doc,
    .g-wrap,
    .g-flow,
    .g-all {
        width: 1205px;
        margin: 0 auto;
        text-align: left;
    }

    .f-cb:after,
    .f-cbli li:after {
        display: block;
        clear: both;
        visibility: hidden;
        height: 0;
        overflow: hidden;
        content: ".";
    }

    .g-mn2 {
        float: left;
        width: 100%;
    }

    .m-breadcrumbBox {
        background-color: transparent;
        color: #666;
        font-size: 0;
        padding: 20px 0 20px 0;
    }

    .m-breadcrumbBox {
        background: #fff;
    }
</style>


// WEBPACK FOOTER //
// src/components/train/live.vue